import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/app/[locale]/error.tsx");
